export default __webpack_public_path__ + "static/media/pin_pon.f9968794.png";